export const ServiceConstants = {
    CATEGORIES: '/categories',
    COUNTRIES: '/countries',
    BRANDS: '/brands',
    SUPPLIERS: '/suppliers',
    PROMOTIONS: '/promotion-types',
    ATTRIBUTES: '/attributes',
    ATTRIBUTES_TYPES: '/attributes/attribute-groups',
    RETAILERS: '/retailers',
    RETAILERS_TYPES: '/retailers/retailer-types',
    EXTRACTS: '/extracts',
    SKUS: '/skus',
    SKU_SEARCH: '/skus/search',
    SKUS_LAST_UPDATED: '/skus/last-updated',
    SKUS_PRICES: '/skus/prices',
    PASSPORT_HELP_ACCOUNT_MANAGERS: '/account-managers',
    PASSPORT_HELP_OFFICES: '/contact-us/offices',
    PASSPORT_HELP_FEEDBACK: '/contact-us/feedback',
    PASSPORT_HELP_TECH_SUPPORT: '/contact-us/tech-support',
    DEFINITIONS: '/definitions',
    HELP_SERVICE_CATEGORY_DEFINITIONS: '/categorydefinitions',
    HELP_SERVICE_FAQ_CATEGORIES: '/faq-categories',
    HELP_SERVICE_FAQS: '/faq-categories/faqs',
    SKU_SEARCH_SUGGESTION: '/skus/search/suggestions',
    EXCHANGERATES: '/exchangerates',
    METADATA_IMAGE_SAS: '/metadata/images/sas',
};
